import React, { useState, useEffect, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Import Login
import Login from './pages/Login';

// Import components directly
import { Layout } from './components/Layout';

// Lazy load pages
const Dashboard = React.lazy(() => import('./pages/Dashboard').then(module => ({default: module.Dashboard})));
const Onboarding = React.lazy(() => import('./pages/Onboarding').then(module => ({default: module.Onboarding})));
const OnboardingNew = React.lazy(() => import('./pages/OnboardingNew').then(module => ({default: module.OnboardingNew})));
const Sessions = React.lazy(() => import('./pages/Sessions').then(module => ({default: module.Sessions})));
const Agents = React.lazy(() => import('./pages/Agents').then(module => ({default: module.Agents})));
const Kanban = React.lazy(() => import('./pages/Kanban').then(module => ({default: module.Kanban})));
const Chat = React.lazy(() => import('./pages/Chat').then(module => ({default: module.Chat})));
const Channels = React.lazy(() => import('./pages/Channels').then(module => ({default: module.Channels})));
const Nodes = React.lazy(() => import('./pages/Nodes').then(module => ({default: module.Nodes})));
const LiveTasks = React.lazy(() => import('./pages/LiveTasks').then(module => ({default: module.LiveTasks})));

const Loading = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-cyan-400">Loading...</div>
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('auth_token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user has valid token
    const token = localStorage.getItem('auth_token');
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = (token) => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('phone_number');
    setIsAuthenticated(false);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
        
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout onLogout={handleLogout}>
                <Suspense fallback={<Loading />}>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/onboarding" element={<Onboarding />} />
                    <Route path="/onboarding-wizard" element={<OnboardingNew />} />
                    <Route path="/sessions" element={<Sessions />} />
                    <Route path="/agents" element={<Agents />} />
                    <Route path="/kanban" element={<Kanban />} />
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/channels" element={<Channels />} />
                    <Route path="/nodes" element={<Nodes />} />
                    <Route path="/live-tasks" element={<LiveTasks />} />
                  </Routes>
                </Suspense>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
